export const SystemDefaultColors = {
  PRIMARY_COLOR: '#004CD3',
  SECONDARY_COLOR: '#327AFA',
  DEFAULT_COLOR: '#979797',
  PRIMARY_BLUE: '#004CD3',
  PRIMARY_FONT_COLOR: '#024ED4',
  HEADINGS_FONT_COLOR: '#000000',
  FONT_COLOR: '#909090',
  PRIMARY_BACKGROUND: '#FFF',
  PRIMARY_FONT: '#191A1B',
  INPUT_BACKGROUND: '#FFF',
  INPUT_BORDER: '#D4D6D8',
  PLACEHOLDER: '#8C8C8CB2',

  PRIMARY_LIGHT_BACKGROUND: '#ffffff',
  DARK_PRIMARY_LIGHT_BACKGROUND: '#2D2B2F',
  PRIMARY_BUTTON: '#00B6C2',
  GREEN_BACKGROUND: '#EFFEFF',
  BUTTON_SELECTED_BACKGROUND: '#EFFEFF',
  ANTD_BUTTON_PRIMARY: '#00B6C2',
  PRIMARY_FONT_BLACK: '#3A3541CC',
  TABLE_HEADER_BACKGROUND: '#EFFEFF',
  DARK_TABLE_HEADER_BACKGROUND: '#2C2930',
  TABS_HEADER_FONT: '#0089BD',
  PUBLISH_TO_WEB_BUTTON: '#AACE38',
  UNPUBLISH_BUTTON: '#CB9D40',
};
